var _style, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".if{fill:#2e2e2e}.is{stroke:#2e2e2e}.bf{fill:#207dff}.bs{stroke:#207dff}\n@media(prefers-color-scheme:dark){.if{fill:#e1e1e1}.is{stroke:#e1e1e1}}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "if",
    x: 11,
    y: 11,
    width: 18,
    height: 18,
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "if",
    x: 11,
    y: 35,
    width: 18,
    height: 18,
    rx: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "if",
    x: 35,
    y: 35,
    width: 18,
    height: 18,
    rx: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "bf",
    x: 37,
    y: 8,
    width: 18,
    height: 18,
    rx: 5,
    transform: "rotate(15 46 17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0dad9f0b706fbbde377d8ed8d8ae0b8a.svg";
export { ForwardRef as ReactComponent };